import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const LIME = [200, 230, 0];
const PETROL = [10, 26, 36];
const GRAY = [107, 114, 128];
const TEXT = [17, 24, 39];
const LIGHT = [243, 244, 246];

export function exportManualPDF() {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const margin = 15;
  let y = 0;

  const today = new Date().toLocaleDateString("es-EC", {
    timeZone: "America/Guayaquil", day: "2-digit", month: "long", year: "numeric",
  });

  // --- Helpers ---
  const ensureSpace = (needed) => {
    if (y + needed > pageH - 18) {
      addFooter();
      doc.addPage();
      y = margin;
      addHeader(false);
    }
  };

  const addHeader = (isCover = false) => {
    if (isCover) return;
    doc.setFillColor(...PETROL);
    doc.rect(0, 0, pageW, 8, "F");
    doc.setFillColor(...LIME);
    doc.rect(0, 8, pageW, 0.5, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text("ALFA-FIELD CONNECT · MANUAL DE USUARIO", margin, 5.5);
    y = 15;
  };

  const addFooter = () => {
    const pn = doc.internal.getNumberOfPages();
    doc.setDrawColor(229, 231, 235);
    doc.line(margin, pageH - 12, pageW - margin, pageH - 12);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.setTextColor(...GRAY);
    doc.text("TELEALFACOM S.A. · Documento interno", margin, pageH - 7);
    doc.text(`Página ${pn}`, pageW - margin, pageH - 7, { align: "right" });
  };

  const h1 = (text) => {
    ensureSpace(14);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(...PETROL);
    doc.text(text, margin, y);
    doc.setDrawColor(...LIME);
    doc.setLineWidth(0.8);
    doc.line(margin, y + 1.5, margin + 12, y + 1.5);
    doc.setLineWidth(0.2);
    y += 9;
  };

  const h2 = (text) => {
    ensureSpace(10);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(...PETROL);
    doc.text(text, margin, y);
    y += 6;
  };

  const para = (text) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9.5);
    doc.setTextColor(...TEXT);
    const lines = doc.splitTextToSize(text, pageW - margin * 2);
    lines.forEach((ln) => {
      ensureSpace(5);
      doc.text(ln, margin, y);
      y += 4.6;
    });
    y += 1.5;
  };

  const bullet = (text) => {
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9.5);
    doc.setTextColor(...TEXT);
    const lines = doc.splitTextToSize(text, pageW - margin * 2 - 6);
    ensureSpace(lines.length * 4.6 + 1);
    doc.setFillColor(...LIME);
    doc.circle(margin + 1.5, y - 1.4, 0.9, "F");
    lines.forEach((ln, i) => {
      doc.text(ln, margin + 6, y);
      y += 4.6;
    });
    y += 0.5;
  };

  const quote = (text) => {
    doc.setFont("helvetica", "italic");
    doc.setFontSize(9);
    doc.setTextColor(...PETROL);
    const lines = doc.splitTextToSize(text, pageW - margin * 2 - 8);
    const h = lines.length * 4.4 + 4;
    ensureSpace(h);
    doc.setFillColor(248, 250, 252);
    doc.rect(margin, y - 2, pageW - margin * 2, h - 1, "F");
    doc.setFillColor(...LIME);
    doc.rect(margin, y - 2, 1.2, h - 1, "F");
    let yy = y + 2;
    lines.forEach((ln) => {
      doc.text(ln, margin + 5, yy);
      yy += 4.4;
    });
    y += h + 1;
  };

  const tableSimple = (head, rows, opts = {}) => {
    autoTable(doc, {
      startY: y,
      head: [head],
      body: rows,
      theme: "grid",
      styles: { fontSize: 8.5, cellPadding: 2.2, lineColor: [229, 231, 235], textColor: TEXT },
      headStyles: { fillColor: PETROL, textColor: 255, fontSize: 8, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [249, 250, 251] },
      margin: { left: margin, right: margin },
      ...opts,
    });
    y = doc.lastAutoTable.finalY + 5;
  };

  // ===== COVER =====
  doc.setFillColor(...PETROL);
  doc.rect(0, 0, pageW, pageH, "F");
  doc.setFillColor(...LIME);
  doc.rect(0, pageH * 0.55, pageW, 1.2, "F");

  // Brand
  doc.setTextColor(...LIME);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("TELEALFACOM S.A.", margin, 30);

  doc.setTextColor(255, 255, 255);
  doc.setFontSize(36);
  doc.text("Alfa-Field", margin, 90);
  doc.setTextColor(...LIME);
  doc.text("Connect", margin, 108);

  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(14);
  doc.text("Manual de Usuario", margin, 125);

  doc.setFontSize(10);
  doc.setTextColor(180, 180, 180);
  doc.text("Plataforma de gestión de campo · Fibra óptica", margin, 134);

  // Footer cover
  doc.setFontSize(8);
  doc.setTextColor(160, 160, 160);
  doc.text(`Generado el ${today}`, margin, pageH - 20);
  doc.text("Versión PMV 0.1 · Documento interno confidencial", margin, pageH - 14);

  // ===== Page 2 — Visión general =====
  doc.addPage();
  y = margin;
  addHeader();

  h1("1. Visión general");
  para(
    "Alfa-Field Connect es una plataforma web que centraliza la operación de campo de TELEALFACOM (instalaciones de fibra óptica, asistencias técnicas, traslados y migraciones) desde la asignación de la orden de trabajo hasta la pre-facturación final del contratista."
  );

  h2("¿Qué problema resuelve?");
  bullet("Información de campo dispersa en hojas Excel, WhatsApp y reportes manuales.");
  bullet("Tiempos largos entre la ejecución técnica y la facturación al contratista.");
  bullet("Falta de control automatizado sobre la calidad de la instalación.");
  bullet("Discrepancias entre lo declarado por el contratista y lo realmente instalado.");

  h2("¿Qué aporta?");
  bullet("Una sola fuente de verdad para todo el ciclo de vida de la orden de trabajo.");
  bullet("Validación automática con Vision AI sobre las evidencias fotográficas.");
  bullet("Auditoría GPS para verificar el metraje real de fibra tendida.");
  bullet("Indicadores ejecutivos en tiempo real para la toma de decisiones.");

  h1("2. Roles del sistema");
  para("El sistema tiene 5 perfiles de usuario; cada uno solo ve los módulos que necesita:");
  tableSimple(
    ["Rol", "Para qué sirve", "Módulos visibles"],
    [
      ["Administrador", "Visión completa del negocio.", "Todos"],
      ["Supervisor", "Coordina cuadrillas y revisa fiscalización.", "Dashboard, Agendamiento, Órdenes, Fiscalización, Mapa, NC"],
      ["Técnico", "Ejecuta instalaciones en campo.", "Sólo sus órdenes asignadas"],
      ["Fiscalizador", "Valida fotos y documenta no-conformidades.", "Dashboard, Órdenes, Fiscalización, Mapa, NC"],
      ["Financiero", "Aprueba pre-facturas y SLA.", "Dashboard, Facturación"],
    ],
    { columnStyles: { 0: { cellWidth: 32, fontStyle: "bold" }, 1: { cellWidth: 65 } } }
  );

  h2("Cuentas demo (sólo PMV)");
  tableSimple(
    ["Rol", "Email", "Contraseña"],
    [
      ["Administrador", "admin@alfanet.com", "admin123"],
      ["Supervisor", "supervisor@alfanet.com", "super123"],
      ["Técnico", "tecnico@alfanet.com", "tec123"],
      ["Fiscalizador", "fiscal@alfanet.com", "fiscal123"],
      ["Financiero", "finanzas@alfanet.com", "fin123"],
    ]
  );

  // ===== 3 — Modules =====
  h1("3. Módulos paso a paso");

  // 3.1 Login
  h2("3.1 Pantalla de Login");
  para("Acceso al sistema. Cada usuario ingresa con su correo corporativo y contraseña. El sistema reconoce el rol y muestra solo los módulos correspondientes.");
  quote("\"Cada miembro del equipo entra con su cuenta. El sistema sabe qué puede ver y qué puede hacer según el rol — un técnico nunca verá la facturación de los contratistas.\"");

  // 3.2 Dashboard
  h2("3.2 Dashboard Operativo");
  para("Panel ejecutivo de KPIs. Es la primera pantalla que ven Administrador, Supervisor, Fiscalizador y Financiero.");
  para("KPIs principales:");
  tableSimple(
    ["Indicador", "Significado"],
    [
      ["Total Órdenes", "Volumen de órdenes en los últimos 60 días."],
      ["Lead Time", "Tiempo promedio entre asignación y cierre (días)."],
      ["Efectividad de Cuadrilla", "% de órdenes ejecutadas correctamente."],
      ["Pre-facturación Pendiente", "Monto en USD listo para facturar pero no aprobado."],
      ["Discrepancias GPS >5%", "Instalaciones con diferencia entre declarado y medido."],
      ["No Conformidades abiertas", "Errores documentales sin corregir."],
      ["Asignadas hoy", "Órdenes programadas para el día."],
    ],
    { columnStyles: { 0: { cellWidth: 50, fontStyle: "bold" } } }
  );
  para("Tres gráficos: tendencia de 14 días, distribución por estado (dona) y volumen por tipo de solución (barras).");
  para("El botón \"Exportar reporte PDF\" genera un one-pager corporativo con todos estos datos, listo para imprimir o enviar después de una reunión.");
  quote("\"En cinco segundos cualquier ejecutivo sabe cómo va la operación: cuánta gente está trabajando, qué tan rápido se cierran las órdenes, cuánto dinero está represado y dónde están los problemas.\"");

  // 3.3 Agendamiento
  h2("3.3 Agendamiento");
  para("Calendario semanal donde se ve qué técnico tiene qué orden asignada en qué día. Lo usan Administrador y Supervisor.");
  bullet("Cada fila es un técnico de cuadrilla.");
  bullet("Cada columna es un día de la semana (lunes a domingo).");
  bullet("En cada celda aparecen las órdenes programadas con código, cliente y estado.");
  bullet("Botones de navegación: anterior, hoy, siguiente. Clic en una orden abre el detalle.");
  quote("\"El supervisor ve de un vistazo cómo está distribuida la carga semanal. Si una cuadrilla está sobrecargada y otra ociosa, lo identifica de inmediato.\"");

  // 3.4 Ordenes
  h2("3.4 Órdenes de Trabajo");
  para("El corazón operativo del sistema. Lista todas las órdenes con buscador y filtros, y permite entrar al detalle de cada una. El Técnico solo ve las órdenes asignadas a él.");
  para("Estados (ciclo de vida de una orden):");
  tableSimple(
    ["#", "Estado", "Significado"],
    [
      ["1", "Asignada", "La orden ha sido creada y dada a un técnico."],
      ["2", "En Progreso", "El técnico está ejecutando el trabajo."],
      ["3", "Completada", "El trabajo terminó, las evidencias están cargadas."],
      ["4", "Validada", "Fiscalizador y la IA confirmaron que está bien hecho."],
      ["5", "Facturada", "El sistema generó la pre-factura para el contratista."],
      ["6", "Rechazada", "Algo salió mal; se devuelve para corrección."],
    ],
    { columnStyles: { 0: { cellWidth: 10, halign: "center" }, 1: { cellWidth: 30, fontStyle: "bold" } } }
  );
  para("Vista de detalle: estado actual y botones para avanzar; tipo de solución; datos de cliente; técnico asignado; contratista responsable; auditoría GPS (declarado vs. validado, alerta si diferencia >5%); galería de evidencias con dictamen Vision AI.");

  // 3.5 Fiscalización
  h2("3.5 Fiscalización con Vision AI");
  para("Módulo de control de calidad automatizado. La inteligencia artificial revisa cada foto que sube el técnico y emite un dictamen.");
  para("Tres dictámenes posibles:");
  bullet("Validado (verde): la foto cumple con el estándar.");
  bullet("Observación (rojo): la IA detectó un problema.");
  bullet("Pendiente (gris): aún no procesada.");
  para("Tipos de no conformidad detectables: etiquetado interno incorrecto, falta de etiquetado en roseta, imagen no acorde, imagen poco clara, potencia fuera de parámetros, test de velocidad sin información, falta registro de tensores o roseta óptica, número de contrato erróneo.");
  quote("\"Antes un fiscalizador revisaba foto por foto manualmente. Ahora la IA pre-clasifica todo: el fiscalizador solo abre las marcadas como Observación. Reducimos el tiempo de fiscalización en más del 70%.\"");
  para("Nota técnica: en este PMV los dictámenes Vision AI están simulados. En la siguiente fase se integra un modelo real (Claude Vision o GPT-4o).");

  // 3.6 Mapa GIS
  h2("3.6 Mapa GIS — Expansión de Red");
  para("Mapa geoespacial donde se visualiza todo el tendido de fibra óptica auditado por GPS. Lo usan Fiscalizador, Supervisor y Administrador.");
  bullet("Marcadores verdes: instalaciones validadas, sin discrepancia.");
  bullet("Marcadores rojos: instalaciones con discrepancia GPS mayor al 5%.");
  bullet("Líneas verdes: trazas GPS validadas del tendido de fibra.");
  bullet("Líneas rojas: trazas con alerta de discrepancia.");
  bullet("KPIs: tendido total en km, trazas auditadas, alertas activas.");
  quote("\"Cada técnico que sale al campo lleva el GPS encendido. Comparamos lo que el contratista declaró que instaló con lo que realmente recorrió. Si la diferencia es >5%, salta una alerta. Esto evita pagos por trabajo no realizado.\"");

  // 3.7 Facturacion
  h2("3.7 Control de Facturación");
  para("Módulo de control financiero del flujo de pago a contratistas. Lo usan Financiero y Administrador.");
  para("Columnas: contratista, período, SLA pre-factura, SLA facturación, valor en USD, garantía ácida, estado (Borrador/Aprobada/Rechazada), fecha de recepción.");
  para("KPIs en cabecera: valor total facturado, % de cumplimiento del SLA pre-factura, % de cumplimiento del SLA facturación, cantidad de borradores pendientes.");
  quote("\"El equipo financiero ve cuánto se le debe a cada contratista, si está dentro del SLA pactado y si tiene garantías retenidas. Antes vivía en hojas Excel separadas; ahora es un solo tablero con datos en vivo.\"");

  // 3.8 NC
  h2("3.8 No Conformidades");
  para("Registro de errores documentales detectados por el equipo de fiscalización en los reportes de los contratistas.");
  bullet("Lista con OT, tipo, descripción, contratista responsable y fecha.");
  bullet("Estado: Abierta o Corregida.");
  bullet("Botón \"Marcar corregida\" cuando el contratista subsana el error.");
  bullet("KPIs: NC abiertas, NC corregidas y tasa de corrección (%).");
  quote("\"Cada error queda registrado con el contratista responsable. Sirve para retroalimentar, descontar de pre-factura si corresponde y medir la calidad histórica del contratista.\"");

  // ===== 4 — Guion =====
  h1("4. Guión de presentación recomendado (15 minutos)");
  tableSimple(
    ["Min", "Pantalla", "Qué decir"],
    [
      ["0–1", "Login", "Mostrar los 5 roles. Entrar como Administrador."],
      ["1–4", "Dashboard", "Recorrer KPIs. Mostrar gráficos. Exportar PDF."],
      ["4–6", "Agendamiento", "Calendario semanal. Navegar entre semanas."],
      ["6–9", "Órdenes → Detalle", "Cliente, técnico, auditoría GPS, evidencias."],
      ["9–11", "Fiscalización IA", "Validar una foto. Registrar observación en otra."],
      ["11–13", "Mapa GIS", "Mostrar alertas rojas. Filtrar sólo alertas."],
      ["13–14", "Facturación", "Tabla con SLA y garantías."],
      ["14–15", "No Conformidades", "Marcar una corregida. Cierre."],
    ],
    { columnStyles: { 0: { cellWidth: 18, halign: "center" }, 1: { cellWidth: 38, fontStyle: "bold" } } }
  );

  // ===== 5 — Próxima fase =====
  h1("5. Próxima fase (post-PMV)");
  tableSimple(
    ["Funcionalidad", "Descripción"],
    [
      ["Vision AI real", "Análisis automático con Claude Vision o GPT-4o (hoy mock)."],
      ["App móvil", "iOS / Android con captura de fotos, geofencing y modo offline."],
      ["Integración Odoo", "Sincronización bidireccional vía XML-RPC y REST API."],
      ["Drag-and-drop", "Reasignar órdenes arrastrando entre técnicos."],
      ["Firma electrónica", "Captura de firma del cliente al cerrar la instalación."],
      ["Notificaciones", "Alertas push a supervisores y técnicos."],
      ["Reportería avanzada", "Exportar a Excel y PDF con filtros personalizados."],
    ],
    { columnStyles: { 0: { cellWidth: 50, fontStyle: "bold" } } }
  );

  h1("6. Datos del PMV (referencia rápida)");
  para("Este demo viene precargado con:");
  bullet("5 usuarios (uno por cada rol).");
  bullet("9 técnicos de cuadrilla.");
  bullet("16 contratistas (nombres reales del catálogo).");
  bullet("48 órdenes de trabajo distribuidas entre estados.");
  bullet("~99 evidencias fotográficas con dictamen Vision AI.");
  bullet("25 no conformidades documentales.");
  bullet("80 registros de facturación de los últimos 5 períodos.");
  para("Toda la información se siembra automáticamente al arrancar el sistema. Los cambios que hagas durante la presentación se persisten en la base de datos.");

  // Footer on every page after first
  const totalPages = doc.internal.getNumberOfPages();
  for (let p = 2; p <= totalPages; p++) {
    doc.setPage(p);
    addFooter();
  }

  doc.save(`AlfaFieldConnect_Manual_Usuario.pdf`);
}
